"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _CallToAction = _interopRequireDefault(require("../../../../molecules/CallToAction"));

var _LocationBase = _interopRequireDefault(require("../LocationBase/LocationBase"));

require("./location_collection.css");

var LocationsCollection = function LocationsCollection(_ref) {
  var _ref$locationHeader = _ref.locationHeader,
      locationHeader = _ref$locationHeader === void 0 ? false : _ref$locationHeader,
      _ref$sectionHeader = _ref.sectionHeader,
      sectionHeader = _ref$sectionHeader === void 0 ? false : _ref$sectionHeader,
      _ref$headerHorizontal = _ref.headerHorizontalAlign,
      headerHorizontalAlign = _ref$headerHorizontal === void 0 ? "center" : _ref$headerHorizontal,
      locations = _ref.locations,
      verticalAlign = _ref.verticalAlign,
      horizontalAlign = _ref.horizontalAlign;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, sectionHeader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    as: "h3",
    textAlign: headerHorizontalAlign,
    className: "location-collection-header"
  }, sectionHeader), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    columns: locations.length,
    verticalAlign: verticalAlign,
    textAlign: horizontalAlign,
    stackable: true
  }, locations.map(function (_ref2, index) {
    var _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? undefined : _ref2$name,
        ctas = _ref2.ctas,
        email = _ref2.email,
        street = _ref2.street,
        city = _ref2.city,
        state = _ref2.state,
        zipCode = _ref2.zip_code,
        country = _ref2.country,
        phoneNumber = _ref2.phone_number,
        hours = _ref2.hours;
    var address = {
      street: street,
      city: city,
      state: state,
      zip: zipCode,
      country: country
    };
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      key: index
    }, locationHeader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h4",
      className: "location-collection-location-header"
    }, name || city), /*#__PURE__*/_react["default"].createElement(_LocationBase["default"], {
      address: address,
      email: email,
      phoneNumber: phoneNumber,
      hours: hours
    }), ctas && ctas.map(function (cta) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: '1rem 0'
        }
      }, /*#__PURE__*/_react["default"].createElement(_CallToAction["default"], cta));
    }));
  })));
};

var _default = LocationsCollection;
exports["default"] = _default;